<template>
  <w-icon-wrapper icon-name='work-calendar-icon'>
    <path
      id='_39_Kalender_Icon'
      d='M20.068,2V1a1.009,1.009,0,0,0-2.017,0V2H5.949V1A1.009,1.009,0,0,0,3.932,1V2H-.022V24h24V2ZM3.932,4V5A1.009,1.009,0,0,0,5.949,5V4h12.1V5a1.009,1.009,0,0,0,2.017,0V4h1.893V8H2V4ZM2,22V10H21.961V22Z'
      data-name='39 Kalender_Icon'
      fill='currentColor'
      transform='translate(0.022)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCalendar' };
</script>
